import styles from './styles.module.scss';
import { ClassName } from '@/blocks/components/types';
import typography from '@/styles/typography.module.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactNode } from 'react';

export function Card({
  children,
  header,
  headerClassname,
  subtitle,
  className,
  innerClassName,
}: PropsWithChildren<{
  subtitle?: string;
  header?: ReactNode;
  className?: ClassName;
  innerClassName?: ClassName;
  headerClassname?: ClassName;
}>) {
  return (
    <div className={classNames(styles.card, className)}>
      {header || subtitle ? (
        <div className={classNames(styles.cardHeaderBlock)}>
          {header ? <h2 className={classNames(headerClassname, styles.cardHeader)}>{header}</h2> : null}
          {subtitle ? <p className={classNames(typography.bodyM, styles.cardSubtitle)}>{subtitle}</p> : null}
        </div>
      ) : null}
      <div className={classNames(innerClassName)}>{children}</div>
    </div>
  );
}

export { default as cardStyles } from './styles.module.scss';
